var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSortIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 297,
  height: 208
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(120)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 177,
  height: 37,
  rx: 18.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 150,
  height: 37,
  y: 57,
  rx: 18.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 124,
  height: 37,
  y: 114,
  rx: 18.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 97,
  height: 37,
  y: 171,
  rx: 18.5
})), /*#__PURE__*/React.createElement("path", {
  d: "m51 171.959 44.291-49.634a3.35 3.35 0 0 1 5.338.448 5.926 5.926 0 0 1-.596 7.099l-46.227 51.803A3.35 3.35 0 0 1 51 182.781a3.34 3.34 0 0 1-2.806-1.106L1.967 129.872a5.926 5.926 0 0 1-.596-7.099 3.35 3.35 0 0 1 5.338-.448zM51 37.041l44.291 49.634a3.35 3.35 0 0 0 5.338-.448 5.926 5.926 0 0 0-.596-7.099L53.806 27.325A3.35 3.35 0 0 0 51 26.219a3.34 3.34 0 0 0-2.806 1.106L1.967 79.128a5.926 5.926 0 0 0-.596 7.099 3.35 3.35 0 0 0 5.338.448z"
}))));
export { SvgSortIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/sort-icon.ae0f7355.svg";